export default class AdminExternalReferrals {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminExternalReferralsRoute, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminExternalReferralsRoute}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminExternalReferralsRoute}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  downloadPDF(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminExternalReferralsRoute}/${id}/download-pdf`, {})
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminExternalReferralsRoute}`, payload)
  }
}
